<template>
  <footer class="footer">
    <div class="footer-top section">
      <div class="container">
        <div class="footer-brand">
          <a href="#" class="logo">Dental.</a>

          <p class="footer-text">
            Mauris non nisi semper, lacinia neque in, dapibus leo. Curabitur
            sagittis libero tincidunt tempor finibus. Mauris at dignissim
            ligula, nec tristique orci.Quisque vitae metus.
          </p>

          <div class="schedule">
            <div class="schedule-icon">
              <ion-icon name="time-outline"></ion-icon>
            </div>

            <span class="span">
              Monday - Saturday:<br />
              9:00am - 10:00Pm
            </span>
          </div>
        </div>

        <ul class="footer-list">
          <li>
            <p class="footer-list-title">Other Links</p>
          </li>

          <li>
            <router-link to="/dental/" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">Home</span>
            </router-link>
          </li>

          <li>
            <router-link to="/dental/About" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">About Us</span>
            </router-link>
          </li>

          <li>
            <router-link to="/dental/Service" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">Services</span>
            </router-link>
          </li>

          <li>
            <router-link to="/dental/Blog" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">Project</span>
            </router-link>
          </li>

          <li>
            <router-link to="/dental/Doctors" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">Our Team</span>
            </router-link>
          </li>

          <li>
            <router-link to="/dental/Blog" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">Latest Blog</span>
            </router-link>
          </li>
        </ul>

        <ul class="footer-list">
          <li>
            <p class="footer-list-title">Our Services</p>
          </li>

          <li>
            <a href="#" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">Root Canal</span>
            </a>
          </li>

          <li>
            <a href="#" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">Alignment Teeth</span>
            </a>
          </li>

          <li>
            <a href="#" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">Cosmetic Teeth</span>
            </a>
          </li>

          <li>
            <a href="#" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">Oral Hygiene</span>
            </a>
          </li>

          <li>
            <a href="#" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">Live Advisory</span>
            </a>
          </li>

          <li>
            <a href="#" class="footer-link">
              <ion-icon class="mb" name="remove-outline"></ion-icon>

              <span class="span">Cavity Inspection</span>
            </a>
          </li>
        </ul>

        <ul class="footer-list">
          <li>
            <p class="footer-list-title">Contact Us</p>
          </li>

          <li class="footer-item">
            <div class="item-icon">
              <ion-icon name="location-outline"></ion-icon>
            </div>

            <address class="item-text">
              1247/Plot No. 39, 15th Phase,<br />
              LHB Colony, Kanpur
            </address>
          </li>

          <li class="footer-item">
            <div class="item-icon">
              <ion-icon name="call-outline"></ion-icon>
            </div>

            <a href="tel:+917052101786" class="footer-link">+1-7052-101-786</a>
          </li>

          <li class="footer-item">
            <div class="item-icon">
              <ion-icon name="mail-outline"></ion-icon>
            </div>

            <a href="mailto:dental@example.com" class="footer-link">
              dental@example.com
            </a>
          </li>
        </ul>
      </div>
    </div>

    <div class="footer-bottom">
      <div class="container">
        <p class="copyright">
          &copy; 2023 All Rights Reserved by
          <a target="_blank" href="https://omarsefo.github.io">omarSefo</a>.
        </p>

        <ul class="social-list">
          <li>
            <a href="#" class="social-link">
              <ion-icon name="logo-facebook"></ion-icon>
            </a>
          </li>

          <li>
            <a href="#" class="social-link">
              <ion-icon name="logo-instagram"></ion-icon>
            </a>
          </li>

          <li>
            <a href="#" class="social-link">
              <ion-icon name="logo-twitter"></ion-icon>
            </a>
          </li>
        </ul>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "DentalFooter",
};
</script>
